import { render, staticRenderFns } from "./UseCaseDiagram.vue?vue&type=template&id=4f6ed4ea&scoped=true"
import script from "./UseCaseDiagram.vue?vue&type=script&lang=js"
export * from "./UseCaseDiagram.vue?vue&type=script&lang=js"
import style0 from "./UseCaseDiagram.vue?vue&type=style&index=0&id=4f6ed4ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6ed4ea",
  null
  
)

export default component.exports